import { Injectable, signal } from "@angular/core";
import CustomerSettings from "src/app/models/CustomerSettings";
import CustomerSettingsService from "src/app/services/customer-settings.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
@Injectable({
  providedIn: "root",
})
export class CustomerSettingsDataService {
  constructor(
    private customerSettingsService: CustomerSettingsService,
    private overlayService: GlobalOverlayService,
  ) {}

  private readonly settings = signal<CustomerSettings | null>(null);

  private async loadDataAsync(companyId: string): Promise<CustomerSettings> {
    this.overlayService.show();
    try {
      const settings = await this.customerSettingsService.getAsync(companyId);
      return settings;
    } finally {
      this.overlayService.close();
    }
  }

  async getCustomerSettingsAsync(companyId?: string): Promise<CustomerSettings | null> {
    if (!companyId) {
      return null;
    }

    if (this.settings() && this.settings().companyId === companyId) {
      return this.settings();
    }

    const settings = await this.loadDataAsync(companyId);

    this.settings.set(settings);
    return settings;
  }
}
